// src/pages/PreviousSolutionsAndTriggers.js
import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import NavBar from './components/NavBar';
import FilterBar from './components/FilterBar';
import theme from './theme';
import { useGlobalLoading } from './context/GlobalLoadingContext';
import { DataAndFilterContext } from './context/DataAndFilterContext';

// pies-only component (new file below)
import PreviousSolutionsAndTriggerPies from './components/data_visualizations/PreviousSolutionAndTriggerPies';

// tablekit tables
import PreviousSolutionsTable from './components/detail/tables/PreviousSolutionsTable';
import TriggersTable from './components/detail/tables/TriggersTable';

function PreviousSolutionsAndTriggers() {
  const { loading } = useGlobalLoading();
  const { filteredData } = useContext(DataAndFilterContext);

  if (loading) return <Typography>Loading...</Typography>;

  return (
    <ThemeProvider theme={theme}>
      <NavBar />
      <Box sx={{ padding: 3 }}>
        <Typography variant="h4" gutterBottom>Buying Behaviors</Typography>
        <FilterBar />

        {/* pies only */}
        <Box my={4}>
          <PreviousSolutionsAndTriggerPies />
        </Box>

        {/* Previous Solutions table (from stories) */}
        <Box my={4}>
          <Typography variant="h6" gutterBottom>Previous Solutions</Typography>
          <PreviousSolutionsTable customerStories={filteredData} />
        </Box>

        {/* Triggers table (from stories) */}
        <Box my={4}>
          <Typography variant="h6" gutterBottom>Triggers</Typography>
          <TriggersTable customerStories={filteredData} />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default PreviousSolutionsAndTriggers;
